import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'
import { handleError, handleSingleDataResponse } from '@/services/amio-api/utils/request-utils'
import omit from 'ramda/src/omit'

class EmailsService {
  constructor() {
    this.path = '/emails'
  }

  logEmail(email, action, ignoredHttpStatuses = []) {
    const omitAuthorization = omit('Authorization')
    const headers = omitAuthorization(amioWebappHttpClient.headers)
    return amioWebappHttpClient
      .post(this.path, {email, action}, {headers})
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }
}

export default new EmailsService()
